import * as React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

import { customImageLoader, getAssetSrc, useStaticImage, useResponsiveBreakPoints } from '@restworld/utils-common';

import { ImpressionIllustration } from './';
import { Heading } from '@restworld/ui-ds-base';

export const FrontViewImpressionTextSearchbox = ({
  children,
  algoliaSearchBarElement,
}: {
  children: React.ReactNode;
  algoliaSearchBarElement?: React.ReactNode;
}) => (
  <div className="p-6 flex flex-col gap-8">
    <div>
      <ImpressionTextEl>{children}</ImpressionTextEl>
    </div>
    {algoliaSearchBarElement}
  </div>
);
export const MobileVersionFrontViewImpressionIllust = () => {
  return (
    <div className="flex  lg:hidden flex-col items-center pb-12">
      <div className="flex flex-col  md:items-center items-start  gap-8  ">
        <TopImpressionLogoEl />
        <div className="h-[437px] md:md:w-[327px] w-full">
          <ImpressionImage />
        </div>
      </div>
    </div>
  );
};
export const ImpressionTextEl = ({ children }: { children: React.ReactNode }) => (
  <div className="flex flex-col gap-4">{children}</div>
);
export const TopImpressionLogoEl = () => {
  const { t } = useTranslation('home-page');
  return (
    <div className="flex flex-col lg:items-start md:items-center items-start gap-2">
      <Heading as="span" size={5} color="muted" className="leading-6">
        {t('relay_on_us')}
      </Heading>
      <div className="flex flex-row justify-start gap-0 items-center">
        <Image
          src={getAssetSrc('/utils-assets/miscusi.svg')}
          width="130"
          height="64"
          loader={customImageLoader}
          alt="top-impression-logos"
          className="saturate-25 opacity-50"
        />
        <Image
          src={getAssetSrc('/utils-assets/burger-king.svg')}
          width="120"
          height="64"
          loader={customImageLoader}
          alt="top-impression-logos"
          className="saturate-25 opacity-50"
        />
        <Image
          src={getAssetSrc('/utils-assets/lavazza.svg')}
          width="130"
          height="64"
          loader={customImageLoader}
          alt="top-impression-logos"
          className="saturate-25 opacity-50"
        />
      </div>
    </div>
  );
};
export const ImpressionImage = () => {
  const heroImg = useStaticImage('hero', getAssetSrc('/utils-assets/home-page/chef-with-wine.png'));
  return (
    <ImpressionIllustration variant="mobileImageOverlay">
      <div className="hidden lg:block">
        <Image {...heroImg} className="rounded-[20px]" alt="hero" loader={customImageLoader} height="400" width="400" />
      </div>
      <div className="lg:hidden">
        <Image {...heroImg} className="rounded-[20px]" alt="hero" loader={customImageLoader} fill />
      </div>
    </ImpressionIllustration>
  );
};
export const HomePageNavbarTitleContent = () => {
  const { t } = useTranslation('home-page');
  const { isDesktop } = useResponsiveBreakPoints();
  return (
    <div className="flex gap-2 flex-col lg:items-center lg:justify-center">
      <Heading
        as="span"
        size={5}
        weight="medium"
        className={`leading-6.75 ${isDesktop ? 'text-gray-500' : 'text-primary-50'}`}
      >
        {t('how_is_it_going')}
      </Heading>
      <div className="flex gap-1 shrink-0 flex-col lg:flex-row">
        <Heading
          as="span"
          size={1}
          weight="semibold"
          className={`text-4xl leading-[2.273rem] ${isDesktop ? 'text-black' : 'text-white'}`}
        >
          {t('search_for_yours')}
        </Heading>
        <Heading
          as="span"
          size={1}
          weight="semibold"
          className={`text-4xl leading-[2.273rem] ${isDesktop ? 'text-primary-800' : 'text-secondary'}`}
        >
          {t('ideal_job')}
        </Heading>
        <Heading
          as="span"
          size={1}
          weight="semibold"
          className={`text-4xl leading-[2.273rem] ${isDesktop ? 'text-black' : 'text-white'}`}
        >
          {t('today')}
        </Heading>
      </div>
    </div>
  );
};
export const NavbarHomeTitleContent = () => {
  const { t } = useTranslation('home-page');

  return (
    <>
      <h1 className="text-white lg:text-black text-4.5 lg:text-6xl lg:leading-16 font-bold">
        {t('meeting_point')} <span className="text-secondary lg:text-primary">{t('catering')}</span>
      </h1>
      <p className="text-white lg:text-gray-600 font-normal text-base lg:text-xl leading-6 lg:leading-7.5 hidden lg:block">
        {t('find_job_in_horeca')}
        <br /> <span>{t('start_professional_career')}</span>
      </p>
      <p className="text-white lg:text-gray-600 font-normal text-base lg:text-xl leading-6 lg:leading-7.5 lg:hidden">
        {t('find_job_in_horeca')} {t('start_professional_career')}
      </p>
    </>
  );
};
